export class RoleService {
  static parseUserRoles(roleData: unknown): string[] {
    if (!roleData) return [];
    if (Array.isArray(roleData)) {
      return roleData.filter((r) => typeof r === 'string');
    }
    if (typeof roleData === 'string') {
      // Backward compatibility: single string
      try {
        const parsed = JSON.parse(roleData);
        if (Array.isArray(parsed)) {
          return parsed.filter((r) => typeof r === 'string');
        }
      } catch (_) {
        // not JSON, treat as single role
      }
      return [roleData];
    }
    return [];
  }

  static hasRole(user: { role?: unknown } | undefined, roleName: string): boolean {
    const roles = this.parseUserRoles(user?.role);
    return roles.includes(roleName);
  }

  static hasAnyRole(
    user: { role?: unknown } | undefined,
    roleNames: string[] | string
  ): boolean {
    const check = Array.isArray(roleNames) ? roleNames : [roleNames];
    const roles = this.parseUserRoles(user?.role);
    return check.some((r) => roles.includes(r));
  }

  static hasAllRoles(
    user: { role?: unknown } | undefined,
    roleNames: string[] | string
  ): boolean {
    const check = Array.isArray(roleNames) ? roleNames : [roleNames];
    const roles = this.parseUserRoles(user?.role);
    return check.every((r) => roles.includes(r));
  }

  static getPrimaryRole(user: { role?: unknown } | undefined): string | null {
    const roles = this.parseUserRoles(user?.role);
    return roles.length > 0 ? roles[0] : null;
  }

  static getUserRoles(user: { role?: unknown } | undefined): string[] {
    return this.parseUserRoles(user?.role);
  }

  static isAdmin(user: { role?: unknown } | undefined): boolean {
    return this.hasRole(user, 'admin');
  }
  static isHost(user: { role?: unknown } | undefined): boolean {
    return this.hasRole(user, 'host');
  }
  static isGuest(user: { role?: unknown } | undefined): boolean {
    return this.hasRole(user, 'guest');
  }
  static isDriver(user: { role?: unknown } | undefined): boolean {
    return this.hasRole(user, 'driver');
  }
  static isPartner(user: { role?: unknown } | undefined): boolean {
    return this.hasRole(user, 'partner');
  }
}

export default RoleService;


